import './css/app.css';

document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('northcoast-ready');

    initRevealItems();
    initMobileMenus();
});

function initRevealItems() {
    const revealItems = document.querySelectorAll('[data-reveal]');

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                });
            },
            {
                threshold: 0.18,
                rootMargin: '0px 0px -72px 0px',
            }
        );

        revealItems.forEach((element) => observer.observe(element));
        return;
    }

    revealItems.forEach((element) => element.classList.add('is-visible'));
}

function initMobileMenus() {
    const menuRoots = document.querySelectorAll('[data-mobile-menu]');

    if (!menuRoots.length) {
        return;
    }

    menuRoots.forEach((menuRoot) => {
        const openButton = menuRoot.querySelector('[data-mobile-menu-open]');
        const canvas = menuRoot.querySelector('[data-mobile-menu-canvas]');
        const overlay = menuRoot.querySelector('[data-mobile-menu-overlay]');
        const panel = menuRoot.querySelector('[data-mobile-menu-panel]');
        const closeButton = menuRoot.querySelector('[data-mobile-menu-close]');

        if (!openButton || !canvas || !overlay || !panel || !closeButton) {
            return;
        }

        let closeTimer = null;

        const getDirectChild = (element, selector) =>
            Array.from(element.children).find((child) => child.matches(selector)) || null;

        const getItemRow = (item) => getDirectChild(item, '.js-mobile-menu-row');
        const getItemSubmenu = (item) => getDirectChild(item, '.sub-menu');
        const getItemToggle = (item) => {
            const row = getItemRow(item);
            return row ? row.querySelector('[data-mobile-submenu-toggle]') : null;
        };

        const collapseItem = (item) => {
            const toggle = getItemToggle(item);
            const submenu = getItemSubmenu(item);

            if (!toggle || !submenu) {
                return;
            }

            toggle.setAttribute('aria-expanded', 'false');
            toggle.classList.remove('border-primary/20', 'bg-secondary-alt/35', 'text-primary');
            submenu.classList.add('hidden');

            const icon = toggle.querySelector('svg');

            if (icon) {
                icon.classList.remove('rotate-180');
            }

            submenu.querySelectorAll('.js-mobile-submenu-parent').forEach((childItem) => {
                if (childItem !== item) {
                    collapseItem(childItem);
                }
            });
        };

        const closeSiblingItems = (item) => {
            const parentList = item.parentElement;

            if (!parentList) {
                return;
            }

            Array.from(parentList.children).forEach((sibling) => {
                if (sibling !== item && sibling.classList.contains('js-mobile-submenu-parent')) {
                    collapseItem(sibling);
                }
            });
        };

        const expandItem = (item) => {
            const toggle = getItemToggle(item);
            const submenu = getItemSubmenu(item);

            if (!toggle || !submenu) {
                return;
            }

            closeSiblingItems(item);

            toggle.setAttribute('aria-expanded', 'true');
            toggle.classList.add('border-primary/20', 'bg-secondary-alt/35', 'text-primary');
            submenu.classList.remove('hidden');

            const icon = toggle.querySelector('svg');

            if (icon) {
                icon.classList.add('rotate-180');
            }
        };

        const closeAllSubmenus = () => {
            canvas.querySelectorAll('.js-mobile-submenu-parent').forEach((item) => {
                collapseItem(item);
            });
        };

        const openMenu = () => {
            window.clearTimeout(closeTimer);
            canvas.classList.remove('hidden');
            canvas.setAttribute('aria-hidden', 'false');
            openButton.setAttribute('aria-expanded', 'true');
            document.body.classList.add('overflow-hidden');

            window.requestAnimationFrame(() => {
                overlay.classList.add('opacity-100');
                panel.classList.remove('translate-x-full');
            });
        };

        const closeMenu = () => {
            window.clearTimeout(closeTimer);
            overlay.classList.remove('opacity-100');
            panel.classList.add('translate-x-full');
            canvas.setAttribute('aria-hidden', 'true');
            openButton.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('overflow-hidden');
            closeAllSubmenus();

            closeTimer = window.setTimeout(() => {
                canvas.classList.add('hidden');
            }, 300);
        };

        openButton.addEventListener('click', (event) => {
            event.preventDefault();
            openMenu();
        });

        closeButton.addEventListener('click', (event) => {
            event.preventDefault();
            closeMenu();
        });

        overlay.addEventListener('click', closeMenu);

        canvas.querySelectorAll('[data-mobile-submenu-toggle]').forEach((toggle) => {
            toggle.addEventListener('click', (event) => {
                event.preventDefault();

                const item = toggle.closest('.js-mobile-submenu-parent');

                if (!item) {
                    return;
                }

                if ('true' === toggle.getAttribute('aria-expanded')) {
                    collapseItem(item);
                    return;
                }

                expandItem(item);
            });
        });

        document.addEventListener('keydown', (event) => {
            if ('Escape' === event.key && !canvas.classList.contains('hidden')) {
                closeMenu();
            }
        });

        window.addEventListener('resize', () => {
            if (window.innerWidth >= 1024 && !canvas.classList.contains('hidden')) {
                closeMenu();
            }
        });
    });
}
